module.exports = __webpack_public_path__ + "assets/photo.4be09e728ceb16442692a863fbbd6dab.png";